import { Alert, Stack, Typography } from '@mui/material';
import { readImpersonation } from '@/support/session';

export default function ReturnToAdmin() {
  return <Stack spacing={2}>
    <Typography component="h1" variant="h4">Return to your account</Typography>
    <Alert severity="info">{readImpersonation()
      ? 'Use End impersonation above to restore your original account.'
      : 'This session is not impersonating another account.'}</Alert>
  </Stack>;
}
